export function getJSON() {
    let ccaas_file = require('../config/ccaa/cps.json');
    return JSON.parse(JSON.stringify(ccaas_file))['ccaas'];
}

export function getCCAAs() {
    let json = getJSON();

    let data = {};

    for (let i in json) {
        let val = json[i];

        // Add ccaa | provincia | partido judicial | localidad | cp ayuntamiento
        if (data[val[0]] === undefined) {
            data[val[0]] = {};
        }
    }

    return data;
}

export function getProvinces() {
    let json = getJSON();

    let data = {};

    for (let i in json) {
        let val = json[i];

        if (data[val[1]] === undefined) {
            data[val[1]] = {
                ccaa: val[0],
            };
        }
    }

    return data;
}

export function getJudicialParties() {
    let json = getJSON();

    let data = {};

    for (let i in json) {
        let val = json[i];

        if (data[val[2]] === undefined) {
            data[val[2]] = {
                ccaa: val[0],
                province: val[1],
                town: val[3],
                cp_town_hall: val[4],
            };
        }
    }

    return data;
}

export function getTowns() {
    let json = getJSON();

    let data = {};

    for (let i in json) {
        let val = json[i];

        if (data[val[3] + ' (' + val[1] + ')'] === undefined) {
            // ARROYOMOLINOS
            data[val[3] + ' (' + val[1] + ')'] = {
                town: val[3],
                ccaa: val[0],
                province: val[1],
                judicial_party: val[2],
            };
        }
    }

    return data;
}

export function getCPsInformation() {
    let json = getJSON();

    let data = {};

    for (let i in json) {
        let val = json[i];

        if (data[val[4]] === undefined) {
            data[val[4]] = {
                ccaa: val[0],
                province: val[1],
                judicial_party: val[2],
                town: val[3]
            }
        }
    }

    return data;
}

export function getRoadTypes() {
    let road_types_file = require('../config/others/road_types.json');
    return JSON.parse(JSON.stringify(road_types_file))['road_types'];
}
